module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1515-72da08e70a02bf3dfe275fd8b5bacbde.png";